import {useAppDispatch, useAppSelector} from "../../../app/store";
import {Button, Col, Form, Modal} from "react-bootstrap";
import {changePublishLanguages, closePublishModal, publishVersion} from "../../../app/slices/adminGameView";
import AdminLoader from "../AdminLoader";
import React from "react";
import {ADMIN_LANG} from "../../../settings";
import {ExclamationTriangleFill} from "react-bootstrap-icons";

const VersionPublishModal = () => {
    const dispatch = useAppDispatch();
    const {
        loaded,
        error,
        publishOpen,
        publish_error,
        available_for_publish,
        publish_languages,
        active_languages,
        game_id,
        current_version_id,
        version_id,
        versions
    } = useAppSelector((state) => state.adminGameView);

    const currentVersion = versions.find((v) => v.version_id === current_version_id);

    const handlePublish = () => {
        dispatch(publishVersion({publish_languages, game_id, version_id: current_version_id}));
    }

    const handlePublishChange = (lang: string) => {
        if (publish_languages.includes(lang)) {
            dispatch(changePublishLanguages(publish_languages.filter((l) => l !== lang)));
        } else {
            dispatch(changePublishLanguages([...publish_languages, lang]));
        }
    }


    return (
        <Modal size='lg' show={publishOpen} onHide={() => dispatch(closePublishModal())} className='admin-modal'>
            {!loaded && <AdminLoader/>}
            <Modal.Header closeButton>
                <Modal.Title>{ADMIN_LANG.version} #{currentVersion?.number}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error && (
                    <div className='alert alert-danger' dangerouslySetInnerHTML={{__html:error}}></div>
                )}
                {publish_error && (
                    <div className='alert alert-warning' dangerouslySetInnerHTML={{__html:publish_error}}></div>
                )}
                {version_id && (
                    <div className='text-info fw-semibold pb-3'>
                    <p>
                        <ExclamationTriangleFill className="me-2"/>
                        {ADMIN_LANG.version_override_help}
                    </p>
                    </div>
                )}
                <Form onSubmit={handlePublish} id="publish-version" className="row gy-3">
                    <Col xs={12}>
                        {active_languages.map((lang) => (
                            <Form.Group key={lang} controlId={`publish-${lang}`}>
                                <Form.Switch
                                    label={`${ADMIN_LANG.publish_in} ${lang.toUpperCase()}`}
                                    disabled={!available_for_publish.includes(lang)}
                                    checked={publish_languages.includes(lang)}
                                    onChange={() => handlePublishChange(lang)}
                                    className='form-label'
                                />
                            </Form.Group>
                        ))}
                    </Col>
                </Form>

            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={() => dispatch(closePublishModal())}>{ADMIN_LANG.cancel}</Button>
                {available_for_publish.length > 0 && publish_languages.length > 0 &&
                <Button variant='primary' type='submit' form='publish-version'>{ADMIN_LANG.publish_version}</Button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default VersionPublishModal;